import React, {useState} from 'react'
import { apiFetch } from './api'
import { useNavigate, Link } from 'react-router-dom'

export default function Signup(){
  const [username,setUsername]=useState('')
  const [password,setPassword]=useState('')
  const [role,setRole]=useState('OPERATOR')
  const [msg,setMsg]=useState(null)
  const [status,setStatus]=useState(null)
  const [loading,setLoading]=useState(false)
  const nav = useNavigate()

  const submit = async e =>{
    e.preventDefault()
    setMsg(null); setStatus(null); setLoading(true)
    try{
      const res = await apiFetch('/api/signup', {method:'POST', headers:{'Content-Type':'application/json'}, credentials:'include', body: JSON.stringify({username: username.trim(), password: password.trim(), role})})
      if (res.ok){ setMsg('Registered — redirecting to login…'); setStatus('success'); setTimeout(()=>nav('/login'),900) }
      else { const b = await res.json().catch(()=>({error:'Signup failed'})); setMsg(b.error||'Signup failed'); setStatus('error') }
    }catch(e){ setMsg('Network error'); setStatus('error') }
    finally{ setLoading(false) }
  }

  return (
    <div className="auth-root">
      <div className={`auth-card ${status==='success' ? 'success' : ''} ${status==='error' ? 'has-error' : ''}`} role="region" aria-labelledby="signup-heading">
        <h2 id="signup-heading" className="auth-title">Create an account</h2>

        {msg && <div className={`auth-msg ${status==='success' ? 'success' : 'error'}`} role="status" aria-live="polite">{msg}</div>}

        <form onSubmit={submit} className="auth-form" noValidate>
          <div className="form-row">
            <label htmlFor="s-username">Username</label>
            <input id="s-username" name="username" value={username} onChange={e=>setUsername(e.target.value)} required />
          </div>

          <div className="form-row">
            <label htmlFor="s-password">Password</label>
            <input id="s-password" name="password" type="password" value={password} onChange={e=>setPassword(e.target.value)} required />
          </div>

          <div className="form-row">
            <label htmlFor="s-role">Role</label>
            <select id="s-role" value={role} onChange={e=>setRole(e.target.value)}>
              <option value="OPERATOR">Operator</option>
              <option value="ADMIN">Admin</option>
            </select>
            <small style={{color:'#5b6b86'}}>Choose a role. Admin users have additional privileges.</small>
          </div>

          <div className="form-actions">
            <button className="btn primary" type="submit" disabled={!username || !password || loading} aria-busy={loading}>{loading ? 'Registering…' : 'Register'}</button>
          </div>
        </form>

        <div className="auth-foot">Already have an account? <Link to="/login">Login</Link></div>
      </div>
    </div>
  )
}
